import { useEffect } from "react";

export function usePageMeta(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr: "name" | "property", key: string, content: string) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
    setMeta("property", "og:title", title);
  }, [title, description, keywords]);
}